/**
 * @generated SignedSource<<01bd65dd057c00f3b43d6eff6ee8e21b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRespondentMasterStatusChoices = "A" | "CS" | "D" | "IW" | "NR" | "NS" | "OQ" | "RT" | "RW" | "S" | "SS" | "T" | "%future added value";
export type ScheduleParticipantInput = {
  clientMutationId?: string | null;
  participantId: string;
  slotId: string;
};
export type ScheduleModal_ScheduleParticipant_Mutation$variables = {
  input: ScheduleParticipantInput;
};
export type ScheduleModal_ScheduleParticipant_Mutation$data = {
  readonly scheduleParticipant: {
    readonly respondent: {
      readonly id: string;
      readonly masterStatus: ScreenersRespondentMasterStatusChoices | null;
    } | null;
    readonly study: {
      readonly approvedTabCount: number | null;
      readonly rejectedCount: number | null;
      readonly scheduledCount: number | null;
    } | null;
  } | null;
};
export type ScheduleModal_ScheduleParticipant_Mutation = {
  response: ScheduleModal_ScheduleParticipant_Mutation$data;
  variables: ScheduleModal_ScheduleParticipant_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "RespondentNode",
  "kind": "LinkedField",
  "name": "respondent",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterStatus",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedTabCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleModal_ScheduleParticipant_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleParticipantPayload",
        "kind": "LinkedField",
        "name": "scheduleParticipant",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScheduleModal_ScheduleParticipant_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ScheduleParticipantPayload",
        "kind": "LinkedField",
        "name": "scheduleParticipant",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c53dba66194104df0fb3d1f800d8d41",
    "id": null,
    "metadata": {},
    "name": "ScheduleModal_ScheduleParticipant_Mutation",
    "operationKind": "mutation",
    "text": "mutation ScheduleModal_ScheduleParticipant_Mutation(\n  $input: ScheduleParticipantInput!\n) {\n  scheduleParticipant(input: $input) {\n    respondent {\n      id\n      masterStatus\n    }\n    study {\n      approvedTabCount\n      scheduledCount\n      rejectedCount\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "86e3b7bc28c5aa266aba7fdcebb3ea0e";

export default node;
